import React, { useState, useEffect } from "react";
import axios from "axios";
import { Heart, Clock } from "lucide-react";

import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useSettings } from "../context/SettingsContext";
import MenuTags from "./MenuTags";

const MenuItemGridView = ({ items, onView, selectedCatId , onRefreshCategories}) => {
  const [favorites, setFavorites] = useState([]);
  const user = useSelector((state) => state.auth.user);
const { settings } = useSettings();
  // ✅ Fetch user favorites from your new API
  useEffect(() => {
    if (user && user.id) {
      axios
        .get(`${window.BASE_API_URL}getuserfav/${user.id}`)
        .then((res) => {
          if (res.data) {
            // expecting backend to return array of IDs
            setFavorites(res.data.map((fav) => fav.menu_id));
          }
        })
        .catch((err) => {
          console.error("Failed to fetch favorites:", err);
        });
    }
  }, [user]);

  // ✅ Toggle favorite
  const handleFavoriteToggle = async (itemId) => {
    if (!user) {
      toast.warn("Please login to add favorites.");
      return;
    }

    const isFav = favorites.includes(itemId);
    const payload = {
      id: itemId,
      selectedCatId: selectedCatId,
      user_id: user.id,
    };

    try {
      if (isFav) {
        await axios.post(`${window.BASE_API_URL}remove-favorite`, payload);
        setFavorites((prev) => prev.filter((id) => id !== itemId));
        toast.info("Removed from favorites.");
        onRefreshCategories();
      } else {
        await axios.post(`${window.BASE_API_URL}add-favorite`, payload);
        setFavorites((prev) => [...prev, itemId]);
        toast.success("Added to favorites!");
        onRefreshCategories();
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong. Try again!");
    }
  };

  if (!items || items.length === 0) return null;

  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-4">
      {items.map((item) => {
        const imageUrl = item.image;
        const isFav = favorites.includes(item.id);

        return (
          <div
            className="menu-card bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
            key={item.id}
          >
            {/* Image + Heart */}
           <div className="relative w-full h-[170px] overflow-hidden imgdiv">
  <div
    className="w-full h-full bg-center bg-cover"
    style={{ backgroundImage: `url(${imageUrl})` }}
  ></div>

  {/* Clock Icon for Custom Prep Items */}
  {item?.is_custom_prep_time == 1 && (
    <div className="absolute top-2 left-2 group">
      <div className="bg-white/90 p-1.5 rounded-full shadow-md">
        <Clock size={20} className="text-orange-600" />
      </div>
      <div
        className="absolute left-0 mt-1 w-max opacity-0 group-hover:opacity-100 
                  transition-opacity duration-200 bg-gray-800 text-white text-xs 
                  rounded px-2 py-1"
      >
        This item has extended prep time
      </div>
    </div>
  )}

  {(user &&
    selectedCatId != "combo" &&
    selectedCatId != "free_item" &&
    selectedCatId != "first_offer" &&
    !String(selectedCatId || "").startsWith("free_")) && (
    <button
      onClick={() => handleFavoriteToggle(item.id)}
      className="absolute top-2 right-2 bg-white/80 hover:bg-white p-1.5 rounded-full shadow-md z-10"
    >
      <Heart
        size={22}
        className={`transition-colors duration-200 ${
          isFav ? "text-red-500 fill-red-500" : "text-gray-500"
        }`}
      />
    </button>
  )}
</div>


            {/* Content */}
            <div className="pl-3 pr-3 pb-3">
              <h3 className="text-lg font-semibold mb-1"  style={{ color: settings?.cart_title_color || "#111827" }}>{item.name}</h3>
              <MenuTags tags={item.tags} />
              <p className="desc text-gray-600 mb-4 line-clamp-2">
                {item.description}
              </p>

              <div className="price-row flex justify-between items-center">
                <span
                  className={`font-bold ${
                    item.is_price == 1 ? "underline decoration-grey-500" : ""
                  }`}
                >
                  {localStorage.getItem("currency")} {item.price.toFixed(2)}

                  
                </span>

                <button
                  onClick={() => onView(item.id)}

style={{
  background: settings?.cart_btn_color || "#000000ff",
   color: settings?.cart_btn_text_color || "#ffffff",
}}
onMouseEnter={(e) => {
  e.currentTarget.style.background =
    settings?.cart_btn_hover || "#f59e0b";
}}
onMouseLeave={(e) => {
  e.currentTarget.style.background =
    settings?.cart_btn_color || "#ffffff";
}}
  

                  className="px-5 py-2 bg-gradient-to-r  to-indigo-600 text-white text-sm font-medium rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 hover:shadow-xl focus:ring-2  focus:outline-none"
                >
                  View
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default MenuItemGridView;
